import { useState, useEffect } from "react";

import { Box, Grid, Typography, Tooltip, TableContainer, Table, TableBody, TableHead, Divider, TableCell, TableRow, IconButton, useTheme, alpha } from "@mui/material";

import dayjs from "dayjs";
import { FormControl, TextField } from '@mui/material';
import 'dayjs/plugin/customParseFormat';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Download as DownloadIcon } from '@mui/icons-material';

import GlobalConfig from "../../../config/date/GlobalConfig";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import Close from '@mui/icons-material/Close';
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import TableFilterRow from "../../../components/table/TableFilterRow";
import CustomPagination from "../../../components/table/CustomPagination";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import { exportToExcel } from "../../../components/ExportToExcel";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

const WIPChildReelReport = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [loading, setLoading] = useState(false);
    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [loadingData, setLoadingData] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');

    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page
    const [currentPage, setCurrentPage] = useState(1);

    //sort columns

    const [sortColumn, setSortColumn] = useState('');
    const [sortDirection, setSortDirection] = useState('asc'); // or 'desc'
    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
        // getFGStockReport();
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
        //getFGStockReport();
    };


    const getReportData = () => {
        const formattedFromMODate = dayjs(FromDate).format('DD-MMM-YYYY');
        const formattedFromMODate1 = dayjs(ToDate).format('DD-MMM-YYYY');


        let parameters = {
            p_companyid: localStorage.getItem('companyid'),
            p_frommodate: formattedFromMODate,
            p_tomodate: formattedFromMODate1
        };
        setLoading(true);
        callApi(API_ENDPOINTS.REPORT_GetreportProductionGetWinderChildRollDetails, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {
                // Update state with fetched data
                setLoadingData(data);
                setLoading(false);
            })
            .catch(error => {
                alert(error);
            });

    };

    useEffect(() => {
        // Fetch data when FromDate or ToDate changes
        getReportData();
    }, [FromDate, ToDate]);


    const [filters, setFilters] = useState({
        pr_number: '',
        child_reel_number: '',
        item_code: '',
        gsm: '',
        width: '',
        length: '',
        child_reel_number_ref: '',
        grade: ''
    });
    const filteredData = loadingData.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const excelColumns = [
        { header: "P.O NO.", key: "po_no" },
        { header: "DATE", key: "date" },
        { header: "SHIFT", key: "shift_code" },
        { header: "ROLL NO", key: "pr_number" },
        { header: "REEL NO", key: "child_reel_number" },
        { header: "QUALITY", key: "item_code" },
        { header: "GSM", key: "gsm" },
        { header: "REEL SIZE", key: "reelsize" },
        { header: "NO OF CUTS", key: "no_of_cuts" },
        { header: "LENGTH (METERS)", key: "reel_length" },
        { header: "REEL DIA", key: "reel_od" },
        { header: "WEIGHT", key: "achieved_qty" },
        { header: "SIZE1", key: "width" },
        { header: "SIZE2", key: "length" },
        { header: "REPULP /HOLD", key: "qc_status" },
        { header: "REMARKS", key: "production_remarks" },
        { header: "GRADE", key: "grade" },
        { header: "REEL REF. NO", key: "child_reel_number_ref" },
        { header: "RE-PULP QUANTITY", key: "repulp_qty" },
        { header: "PARTY REMARKS", key: "party_remarks" },
    ];


    const dateColumnIndexes = [1]; // "DATE"


    const handleExportToExcel = () => {
        exportToExcel({
            data: filteredData,
            fileName: 'Rewinder Production Detail Report.xlsx',
            sheetName: 'Rewinder Production Detail',
            columns: excelColumns,           // 🔁 Fixed name
            dateColumnIndexes,

        });

        // // Prepare the data with headers
        // const formattedData = filteredData.map(row => ({
        //     "P.O NO.": row.po_no,
        //     "DATE": row.date ? new Date(row.date) : "", // ensures proper Excel format
        //     "SHIFT": row.shift_code,
        //     "ROLL NO": row.pr_number,
        //     "REEL NO": row.child_reel_number,
        //     "QUALITY": row.item_code,
        //     "GSM": row.gsm,
        //     "REEL SIZE": row.reelsize,
        //     "NO OF CUTS": row.no_of_cuts,
        //     "LENGTH (METERS)": row.reel_length,
        //     "REEL DIA": row.reel_od,
        //     "WEIGHT": row.achieved_qty,
        //     "SIZE1": row.width,
        //     "SIZE2": row.length,
        //     "REPULP /HOLD": row.qc_status,
        //     "REMARKS": row.production_remarks,
        //     "GRADE": row.grade,
        //     "REEL REF. NO": row.child_reel_number_ref
        // }));



    };

    const HandleClose = () => {
        handleExportToExcel();
    }

    const sortedData = [...filteredData].sort((a, b) => {
        if (!sortColumn) return 0;

        const aValue = a[sortColumn];
        const bValue = b[sortColumn];

        if (typeof aValue === 'number' && typeof bValue === 'number') {
            return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
        }

        return sortDirection === 'asc'
            ? String(aValue).localeCompare(String(bValue))
            : String(bValue).localeCompare(String(aValue));
    });



    const currentRecords = sortedData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const pageCount = Math.ceil(filteredData.length / recordsPerPage);


    const uniqueValues = {
        po_no: [...new Set(loadingData.map(row => row.po_no))],
        shift_code: [...new Set(loadingData.map(row => row.shift_code))],
        pr_number: [...new Set(loadingData.map(row => row.pr_number))],
        child_reel_number: [...new Set(loadingData.map(row => row.child_reel_number))],
        item_code: [...new Set(loadingData.map(row => row.item_code))],
        gsm: [...new Set(loadingData.map(row => row.gsm))],
        grade: [...new Set(loadingData.map(row => row.grade))],
        child_reel_number_ref: [...new Set(loadingData.map(row => row.child_reel_number_ref))],

    };




    const columns = ['po_no', 'date', 'shift_code', 'pr_number', 'child_reel_number', 'item_code', 'gsm', 'reelsize', 'no_of_cuts', 'reel_length', 'reel_od', 'achieved_qty', 'width', 'length', 'qc_status', 'production_remarks', 'grade', 'child_reel_number_ref','repulp_qty', 'party_remarks'];

    const autoCompleteColumns = ['po_no', 'shift_code', 'pr_number', 'child_reel_number', 'item_code', 'gsm', 'grade', 'reel_sheet'];

    const totals = {
        achieved_qty: filteredData.reduce((sum, r) => sum + (parseFloat(r.achieved_qty) || 0), 0),

    };



    const handleSort = (column) => {
        const direction = (sortColumn === column && sortDirection === 'asc') ? 'desc' : 'asc';
        setSortColumn(column);
        setSortDirection(direction);
    };


    //    // Get the records for the current page
    //     const currentRecords = filteredData.slice(
    //         (currentPage - 1) * recordsPerPage,
    //         currentPage * recordsPerPage
    //     );


    const [anchorEl, setAnchorEl] = useState(null);
    const [activePicker, setActivePicker] = useState(null);

    const handleOpen = (event, pickerType) => {
        setAnchorEl(event.currentTarget);
        setActivePicker(pickerType);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setActivePicker(null);
    };

    return (
        <>
            <Divider />
            <Box>
                <Box elevation={2} sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: 2,
                    //   backgroundColor: theme.palette.background.transparent,
                    borderRadius: 2,
                }}>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Rewinder Production Detail Report
                    </Typography>

                    <Divider orientation="vertical" flexItem />

                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography>From:</Typography>
                        <FormControl fullWidth size="small">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    size="small"
                                    value={dayjs(FromDate)}
                                    onChange={handleDateChange2}
                                    autoFocus={true}
                                    format="DD-MMM-YYYY"

                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                        },
                                    }}

                                    renderInput={(props) => <TextField  {...props} />}
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </Box>

                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography>To:</Typography>
                        <FormControl fullWidth size="small">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker

                                    value={dayjs(ToDate)}
                                    onChange={handleDateChange1}
                                    autoFocus={true}
                                    format="DD-MMM-YYYY"
                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                        },
                                    }}
                                    renderInput={(props) => <TextField {...props} />}
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </Box>

                    <Tooltip title="Download Report">
                        <IconButton onClick={handleExportToExcel} color="secondary">
                            <DownloadIcon />
                        </IconButton>
                    </Tooltip>

                    <Grid item mt="2px" ml="5px" mr="auto" justifyContent="center">
                        <IconButton onClick={() => { handleBackWinderMachineEntry() }}>
                            <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                        </IconButton>
                    </Grid>
                </Box>
            </Box>

            <Divider />
            <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>
                <CustomTableContainer colors={colors}>
                    <TableContainer >
                        {loading ? (
                            <SkeletonTableLoader rows={5} columns={11} />
                        ) : (
                            <Table  >
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow>
                                        {/* <TableCell sx={{ textAlign: "center", minWidth: 140, whiteSpace: "nowrap" }}>PO NO.</TableCell> */}
                                        <TableCell
                                            onClick={() => handleSort('po_no')}
                                            sx={{ textAlign: "center", minWidth: 140, whiteSpace: "nowrap", cursor: "pointer" }}
                                        >
                                            PO NO. {sortColumn === 'po_no' ? (sortDirection === 'asc' ? '↑' : '↓') : ''}
                                        </TableCell>

                                        <TableCell onClick={() => handleSort('date')} sx={{ cursor: "pointer", textAlign: "center", minWidth: 80, whiteSpace: "nowrap" }}>
                                            DATE {sortColumn === 'date' ? (sortDirection === 'asc' ? '↑' : '↓') : ''}
                                        </TableCell>

                                        <TableCell onClick={() => handleSort('shift_code')} sx={{ cursor: "pointer" }}>
                                            SHIFT {sortColumn === 'shift_code' ? (sortDirection === 'asc' ? '↑' : '↓') : ''}
                                        </TableCell>

                                        <TableCell onClick={() => handleSort('pr_number')} sx={{ cursor: "pointer", minWidth: 100, whiteSpace: "nowrap" }}>
                                            ROOL NO {sortColumn === 'pr_number' ? (sortDirection === 'asc' ? '↑' : '↓') : ''}
                                        </TableCell>

                                        <TableCell onClick={() => handleSort('child_reel_number')} sx={{ cursor: "pointer", minWidth: 110, whiteSpace: "nowrap" }}>
                                            REEL NO {sortColumn === 'child_reel_number' ? (sortDirection === 'asc' ? '↑' : '↓') : ''}
                                        </TableCell>

                                        <TableCell onClick={() => handleSort('item_code')} sx={{ cursor: "pointer", minWidth: 120, whiteSpace: "nowrap" }}>
                                            QUALITY {sortColumn === 'item_code' ? (sortDirection === 'asc' ? '↑' : '↓') : ''}
                                        </TableCell>

                                        <TableCell onClick={() => handleSort('gsm')} sx={{ cursor: "pointer" }}>
                                            GSM {sortColumn === 'gsm' ? (sortDirection === 'asc' ? '↑' : '↓') : ''}
                                        </TableCell>

                                        <TableCell sx={{ cursor: "pointer", minWidth: 70, whiteSpace: "nowrap" }}>REEL SIZE </TableCell>
                                        <TableCell sx={{ cursor: "pointer", minWidth: 80, whiteSpace: "nowrap" }}>NO OF CUTS </TableCell>
                                        <TableCell >LENGTH (METERS) </TableCell>
                                        <TableCell >REEL DIA </TableCell>
                                        <TableCell >WEIGHT </TableCell>
                                        <TableCell > SIZE1</TableCell>
                                        <TableCell > SIZE2</TableCell>
                                        <TableCell >REPULP /HOLD</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 150, whiteSpace: "nowrap" }}>REMARKS</TableCell>

                                        <TableCell onClick={() => handleSort('grade')} sx={{ cursor: "pointer" }}>
                                            GRADE {sortColumn === 'grade' ? (sortDirection === 'asc' ? '↑' : '↓') : ''}
                                        </TableCell>

                                        <TableCell >REEL REF.NO</TableCell>
                                        <TableCell >RE-PULP QUANTITY</TableCell>
                                        <TableCell >PARTY REMARKS</TableCell>
                                    </TableRow>

                                    <TableFilterRow
                                        columns={columns}
                                        filters={filters}
                                        handleFilterChange={handleFilterChange}
                                        uniqueValues={uniqueValues}
                                        autoCompleteColumns={autoCompleteColumns}
                                    />

                                </TableHead>
                                <TableBody>
                                    {currentRecords.map((row, index) => (
                                        <TableRow key={row.id} sx={{

                                            backgroundColor:
                                                index % 2 === 0
                                                    ? theme.palette.background.default
                                                    : alpha(theme.palette.action.hover, 0.04), // slightly darker
                                        }}>
                                            <TableCell>{row.po_no}</TableCell>
                                            <TableCell>{row.date}</TableCell>
                                            <TableCell>{row.shift_code}</TableCell>
                                            <TableCell>{row.pr_number}</TableCell>
                                            <TableCell>{row.child_reel_number}</TableCell>
                                            <TableCell >{row.item_code}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.gsm}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.reelsize}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.no_of_cuts}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.reel_length}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.reel_od}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.achieved_qty}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.width}</TableCell>
                                            <TableCell sx={{ textAlign: "right" }}>{row.length}</TableCell>
                                            <TableCell>{row.qc_status}</TableCell>
                                            <TableCell>{row.production_remarks}</TableCell>
                                            <TableCell>{row.grade}</TableCell>
                                            <TableCell>{row.child_reel_number_ref}</TableCell>
                                             <TableCell>{row.repulp_qty}</TableCell>
                                              <TableCell>{row.party_remarks}</TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow sx={{ backgroundColor: colors.primary[400], height: 10 }}>
                                        <TableCell colSpan={11} sx={{ fontWeight: 'bold', textAlign: 'right' }}>TOTAL </TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.achieved_qty.toFixed(2)}</TableCell>
                                        <TableCell /> {/* SIZE1 */}
                                        <TableCell /> {/* SIZE2 */}
                                        <TableCell /> {/* REPULP /HOLD */}
                                        <TableCell /> {/* REMARKS */}
                                        <TableCell /> {/* GRADE */}
                                        <TableCell /> {/* REEL REF.NO */}
                                               <TableCell /> 
                                                      <TableCell /> 
                                    </TableRow>
                                </TableBody>
                            </Table>)}

                    </TableContainer>
                </CustomTableContainer>
                <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />
            </ResponsiveBox>

        </>
    )
};
export default WIPChildReelReport;